// extracted by mini-css-extract-plugin
export default {"buttons":"HbbTVButtonOverlay-styles-module__buttons__T7td0"};